import { render } from "./ClearRecordButton.vue?vue&type=template&id=83ea42ea&scoped=true"
import script from "./ClearRecordButton.vue?vue&type=script&lang=ts"
export * from "./ClearRecordButton.vue?vue&type=script&lang=ts"

import "./ClearRecordButton.vue?vue&type=style&index=0&id=83ea42ea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-83ea42ea"

export default script